<template>
  <div>
    <TitleWithButton
      :title="pageTitle"
      :skeleton="isLoadingAsyncData"
      button-text="Скачать отчет"
      button-icon="mdi-arrow-down-bold"
      :creatable="creatable"
      :create-url="createUrl"
      class="mt-1 mb-4 font-weight-bold"
      style="font-size: 16px;"
      @create="onDownload"
    />

    <BTableCommon
      :list="list"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading || isLoadingAsyncData"
      type="publication-storage-files-history"
      @change:pagination="onChangePagination"
      @change:sort="onChangeSort"
    />
  </div>
</template>

<script>
import { lkPublicationStorageFileHistoryPermissions as Permissions } from '@/helpers/enums/permission-models'
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { PublicationStorageFileHistoryModel as Model } from './Model'
import { publicationStorageFilesHistoryStoreModule as StoreModule } from './store'

import BTableCommon from '@/components/tables/BTableCommon.vue'
import TitleWithButton from '@/components/common/TitleWithButton.vue'
import { createPublicationStorageReportModal } from '@/views/Publications/Storage/utils'

const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'PublicationStorageFilesHistoryList',
  $_veeValidate: {
    /** @type 'new' */
    validator: 'new',
  },
  components: {
    BTableCommon,
    TitleWithButton,
  },
  mixins: [listMixin],
  props: {
    publication: {
      type: Object,
      required: true,
      validator: (prop) => prop && 'id' in prop,
    },
    storage: {
      type: Object,
      required: true,
      validator: (prop) => prop && 'id' in prop,
    },
  },
  data() {
    const { storage } = this

    return {
      disabledPaginationQuery: true,
      defaultParams: {
        publication_id: this.publication.id,
        storage_id: storage.id,
      },
    }
  },
  computed: {
    creatable() {
      return this.$access(Permissions.create)
    },
    createUrl() {
      return `/api/v1/publications/publications/${this.publication.id}/storage/${this.storage.id}/files/history-report/`
    },
  },
  methods: {
    async onDownload() {
      const propsData = {
        reportCode: 'storageFile',
        params: { storage_id: this.storage.id },
        title: 'Отчет',
      }
      const modal = await createPublicationStorageReportModal(this, propsData)
      await modal.open()
    },
  },
}
</script>
